import { useImage } from './Hooks/useImage';
import { IImageProps } from './IImageProps';

export const Image: React.FunctionComponent<IImageProps> = (props: IImageProps) => {
  const { image } = useImage(props.fileName, props.src);

  return (
    <>
      <img
        id={props.id}
        title={props.title}
        src={image}
        alt={props.alt}
        style={props.style}
        className={`img-fluid ${props.className ? props.className.padStart(props.className.length + 1) : ''}`}
      />
    </>
  );
};
